import {
  Button,
  Card,
  Form,
  Input,
  message,
  Radio,
  App,
  Spin,
  Upload,
  InputNumber,
  Progress,
} from "antd";
import Uppy from "@uppy/core";
import AwsS3 from "@uppy/aws-s3";
import { Dashboard } from "@uppy/react";
import { useEffect, useState, useMemo } from "react";
import {
  MAGAZINE_SETTING,
  GET_AWS_SIGN_UPLOAD_Magazine,
} from "../../apis/apis";
import { useNavigate } from "react-router-dom";
import CustomRichTextEditor from "../../components/CustomTextEditor";
import {
  Loading3QuartersOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import CulsightPageLoader from "../../components/CulsightPageLoader";

function Magazine() {
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();

  const [errors, set_errors] = useState("");
  // Cover Image
  const [cover_image, set_cover_image] = useState("");
  const [cover_image_api, set_cover_image_api] = useState("");
  const [coverImageError, setCoverImageError] = useState("");
  const [magazine_title, set_magazine_title] = useState("");
  const [magazine_description, set_magazine_description] = useState("");
  const [button_text, set_button_text] = useState("");

  // PDF
  const [pdfUploading, setPdfUploading] = useState(false);
  const [pdfProgress, setPdfProgress] = useState(0);
  const [pdfUploadingMessage, setPdfUploadingMessage] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [uploadCompleted, setUploadCompleted] = useState(false);
  const [JWT_ACCESS_TOKEN_MINUTES, set_JWT_ACCESS_TOKEN_MINUTES] = useState("");
  const [JWT_REFRESH_TOKEN_DAYS, set_JWT_REFRESH_TOKEN_DAYS] = useState("");
  const [maxDownloadLimit, setMaxDownloadLimit] = useState("");

  const uppy = useMemo(() => {
    const uppyInstance = new Uppy({
      autoProceed: true,
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ["application/pdf"],
        //maxFileSize: 20 * 1024 * 1024,
      },
    });

    uppyInstance.use(AwsS3, {
      async getUploadParameters(file) {
        setPdfUploading(true);
        setPdfProgress(0);
        setPdfUploadingMessage("Preparing upload...");

        const formData = new FormData();

        formData.append("filename", file.name);
        formData.append("type", file.type);

        const response = await GET_AWS_SIGN_UPLOAD_Magazine(formData);

        if (!response?.data?.status) {
          throw new Error("Unable to generate signed url");
        }

        const uploadUrl = response.data.uploadUrl;

        const fileKey = response.data.fileKey;
        setPdfUrl(fileKey);

        setPdfUrl(fileKey);

        return {
          method: "PUT",
          url: uploadUrl,
          headers: {
            "Content-Type": file.type,
          },
        };
      },
    });

    uppyInstance.on("upload-progress", (file, progress) => {
      const percent = Math.round(
        (progress.bytesUploaded / progress.bytesTotal) * 100,
      );

      setPdfProgress(percent);
      setPdfUploadingMessage("Uploading PDF...");
    });

    uppyInstance.on("upload-success", () => {
      setPdfUploading(false);

      setPdfProgress(100);

      setUploadCompleted(true);

      notification.success({
        message: "PDF Uploaded Successfully",
      });
    });

    uppyInstance.on("upload-error", () => {
      setPdfUploading(false);

      setPdfProgress(0);

      notification.error({
        message: "Upload Failed",
      });
    });

    return uppyInstance;
  }, []);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleChange = async (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
  };
  const handleCoverChange = async (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }

    set_cover_image_api(info.file);

    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        set_cover_image(url);
      });
    } else if (info.file.status === "error") {
      setLoading(false);
      message.error("Upload failed. Please try again.");
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? (
        <Loading3QuartersOutlined />
      ) : (
        <PlusOutlined style={{ color: "#fff" }} />
      )}
      <div style={{ marginTop: 8, color: "#fff" }}>Upload</div>
    </button>
  );

  const coverUploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? (
        <Loading3QuartersOutlined />
      ) : (
        <PlusOutlined style={{ color: "#fff" }} />
      )}
      <div style={{ marginTop: 8, color: "#fff" }}>Upload</div>
    </button>
  );

  const pdfProps = {
    accept: ".pdf",
    maxCount: 1,
    beforeUpload(file) {
      if (file.type !== "application/pdf") {
        message.error("Only PDF files are allowed.");
        return Upload.LIST_IGNORE;
      }
      //Here we remove the file size check for PDF upload explicitly as per your request. If you want to enforce a size limit, you can uncomment the following lines and line no. 64 and set the desired limit.
      {
        /* const isLt20MB = file.size / 1024 / 1024 < 20;

      if (!isLt20MB) {
        message.error("PDF must be smaller than 20MB.");
        return Upload.LIST_IGNORE;
      }*/
      }

      setPdfUploading(true);
      setPdfProgress(100);
      //setPdfUrl(fileKey);
      setPdfUploading(false);

      return false;
    },
  };

  //ADD API
  const onFinish = async () => {
    setLoading(true);
    const FORM_DATA = new FormData();

    FORM_DATA.append("magazine_cover", cover_image_api);
    FORM_DATA.append("magazine_pdf", pdfUrl);
    FORM_DATA.append("title", magazine_title);
    FORM_DATA.append("description", magazine_description);
    FORM_DATA.append("max_download_limit", maxDownloadLimit);
    FORM_DATA.append("button_text", button_text);

    if (
      JWT_ACCESS_TOKEN_MINUTES !== null &&
      JWT_ACCESS_TOKEN_MINUTES !== undefined
    ) {
      FORM_DATA.append("jwt_access_token_minutes", JWT_ACCESS_TOKEN_MINUTES);
    }
    if (
      JWT_REFRESH_TOKEN_DAYS !== null &&
      JWT_REFRESH_TOKEN_DAYS !== undefined
    ) {
      FORM_DATA.append("jwt_refresh_token_days", JWT_REFRESH_TOKEN_DAYS);
    }

    try {
      const response = await MAGAZINE_SETTING(FORM_DATA);
      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });

        setLoading(false);
        navigate("/app-setting-tab");
      } else {
        setLoading(false);
        set_errors(response?.data?.errors);
      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error"),
      );
    }
  };

  useEffect(() => {
    const view_api = async () => {
      setLoading(true);
      const FORM_DATA = new FormData();
      try {
        const response = await MAGAZINE_SETTING(FORM_DATA);
        if (response?.data?.status) {
          const response_data = response?.data?.data;

          set_magazine_title(response_data?.meta?.magazine_title || "");
          setMaxDownloadLimit(response?.data?.data?.max_download_limit || "");
          set_magazine_description(
            response_data?.meta?.magazine_description || "",
          );
          set_button_text(response_data?.meta?.button_text || "");
          form.setFieldsValue({
            button_text: response_data?.meta?.button_text,
            magazine_title: response_data?.meta?.magazine_title,
            magazine_description: response_data?.meta?.magazine_description,
          });

          set_JWT_ACCESS_TOKEN_MINUTES(
            response_data?.meta?.jwt_access_token_minutes,
          );
          set_JWT_REFRESH_TOKEN_DAYS(
            response_data?.meta?.jwt_refresh_token_days,
          );

          setLoading(false);
        } else {
          setLoading(false);
          set_errors(response?.data?.errors);
        }
      } catch (error) {
        message.error(
          "Server Error: " +
            (error?.response?.data?.message || "Unknown error"),
        );
      }
    };
    view_api();
  }, []);
  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        autoComplete="off"
        validateTrigger="onSubmit"
        onFinish={onFinish}
      >
        <Form.Item label="Magazine Cover Image">
          <Upload
            name="cover_image"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={(file) => {
              const isJpgOrPng =
                file.type === "image/jpeg" ||
                file.type === "image/png" ||
                file.type === "image/jpg";

              const isLt512KB = file.size <= 512 * 1024;

              if (!isJpgOrPng) {
                set_cover_image("");
                set_cover_image_api("");
                setCoverImageError("Only JPG/PNG files are allowed.");
                return false;
              }

              if (!isLt512KB) {
                set_cover_image("");
                set_cover_image_api("");
                setCoverImageError(
                  "Cover image must be smaller than or equal to 512KB.",
                );
                return false;
              }

              const img = new Image();
              img.src = URL.createObjectURL(file);

              img.onload = () => {
                const { width, height } = img;

                if (width === 490 && height === 320) {
                  setCoverImageError("");

                  getBase64(file, (url) => set_cover_image(url));
                  set_cover_image_api(file);
                } else {
                  set_cover_image("");
                  set_cover_image_api("");
                  setCoverImageError("Image must be exactly 490 x 320 pixels.");
                }
              };

              return false;
            }}
            onChange={handleCoverChange}
          >
            {cover_image ? (
              <img
                src={cover_image}
                alt="cover"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              coverUploadButton
            )}
          </Upload>

          {coverImageError && (
            <span
              style={{
                color: "red",
                display: "block",
                marginTop: 8,
              }}
            >
              {coverImageError}
            </span>
          )}

          <p
            style={{
              color: "#65e7c4",
              marginTop: "10px",
            }}
          >
            Note - Cover image must be smaller than or equal to 512KB and must
            be exactly 490 x 320 pixels.
          </p>
        </Form.Item>
        <Form.Item label="Magazine Title">
          <Input
            value={magazine_title}
            onChange={(e) => set_magazine_title(e.target.value)}
          />
          {errors?.magazine_title && (
            <span style={{ color: "red" }}>{errors.magazine_title}</span>
          )}
        </Form.Item>

        <Form.Item label="Magazine Description">
          <Input
            value={magazine_description}
            onChange={(e) => set_magazine_description(e.target.value)}
          />
          {errors?.magazine_description && (
            <span style={{ color: "red" }}>{errors.magazine_description}</span>
          )}
        </Form.Item>

        <Form.Item label="Button Text">
          <Input
            value={button_text}
            onChange={(e) => set_button_text(e.target.value)}
            placeholder="Enter button text"
          />

          {errors?.button_text && (
            <span style={{ color: "red" }}>{errors.button_text}</span>
          )}
        </Form.Item>

        <Form.Item label="Max Download Limit of Magazine">
          <Input
            type="number"
            min={1}
            value={maxDownloadLimit}
            onChange={(e) => setMaxDownloadLimit(e.target.value)}
            placeholder="Enter maximum download limit"
          />
        </Form.Item>
        {/* <Form.Item label="Magazine PDF" style={{ marginTop: 20 }}>
                  <Upload {...pdfProps}>
                    <Button>Upload PDF</Button>
                  </Upload>

                  {pdfUploading && (
                    <Progress
                      percent={pdfProgress}
                      size="small"
                      style={{ marginTop: 10 }}
                    />
                  )}

                  {set_set_pdf_file && (
                    <div style={{ marginTop: 10, color: "green" }}>
                      {set_set_pdf_file.name}
                    </div>
                  )}
                </Form.Item>
                */}
        <Form.Item label="Magazine PDF">
          <Dashboard
            uppy={uppy}
            proudlyDisplayPoweredByUppy={false}
            showRemoveButtonAfterComplete={false}
            height={300}
            width="100%"
          />

          {pdfUploading && (
            <>
              <Progress percent={pdfProgress} status="active" />
              <div>{pdfUploadingMessage}</div>
            </>
          )}
        </Form.Item>

        <Form.Item>
          {loading ? (
            <>
              <Button type="primary" htmlType="submit">
                Save
                <Spin indicator={<LoadingOutlined spin />} size="small" />
              </Button>
            </>
          ) : (
            <>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </>
          )}
        </Form.Item>
      </Form>
    </div>
  );
}

export default Magazine;
